import { render, staticRenderFns } from "./LearnersInfo.vue?vue&type=template&id=191d5bb0"
import script from "./LearnersInfo.vue?vue&type=script&lang=js"
export * from "./LearnersInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports